<template>
  <Loading></Loading>
</template>

<script>
import Loading from "@/components/Page/Liff/Shared/Loading"

export default {
  components: {
    Loading,
  },
  computed: {
    nextRoute() {
      if (this.getModuleConfig('terms_page.enable') ?? false) {
        return 'LiffRegisterTerms'
      } else if (this.getModuleConfig('verify_page.enable') ?? false) {
        return 'LiffRegisterVerifyForm'
      }

      return "LiffRegisterMember"
    }
  },
  mounted() {
    this.$router.push({
      name: this.nextRoute,
      params: {
        orgCode: this.$route.params.orgCode,
      },
      query: this.$route.query,
    })
  },
  methods: {
    getModuleConfig(key) {
      return this.$store.getters["liffModule/getConfig"]('member_register', key)
    },
  }
}
</script>
